






















































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SuporteUsuariosRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteUsuariosRemuneracaoStore';
import { maskCPFCNPJ, maskDate, maskHour } from '@/utils/common';
import ModalLogsSuporteUsuarios from '@/components/RemuneracaoMedica/suporte/components/ModalLogsSuporteUsuarios.vue';
import RemuneracaoSuporteAdminUsuariosRightNavBar from '@/components/RemuneracaoMedica/NavBar/RemuneracaoSuporteAdminUsuariosRightNavBar.vue';

@Component({
  components: {
    ModalLogsSuporteUsuarios,
    RemuneracaoSuporteAdminUsuariosRightNavBar,
  }
})

export default class ViewSuporteUsuarios extends Vue {
  public usuariosTableHeader: any[] = [
    { text: 'Perfil', value: 'perfil', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'CPF', value: 'documento', sortable: false },
    { text: 'Email', value: 'email', sortable: false },
    { text: 'Cliente associado', value: 'clienteFinX', sortable: false },
    { text: 'Tentativa cadastro', value: 'dataCadastro', sortable: false },
    { text: 'Status', value: 'status', sortable: false, align: 'center' },
    { text: 'Ações', value: 'documento', sortable: false, align: 'center' },
  ]

  get getSuporteUsuariosRemuneracaoStore() {
    return getModule(SuporteUsuariosRemuneracaoStore, this.$store)
  }

  get tableLoading() {
    return this.getSuporteUsuariosRemuneracaoStore.filterLoading
  }

  set tableLoading(value: boolean) {
    this.getSuporteUsuariosRemuneracaoStore.setFilterLoading(value)
  }

  get usuarios() {
    return this.getSuporteUsuariosRemuneracaoStore.usuarios
  }

  get pagination() {
    return this.getSuporteUsuariosRemuneracaoStore.pagination
  }

  get remuneracaoLength() {
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  get itemsLength() {
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPage() {
    return this.pagination.page
  }

  set getPage(value: number) {
    this.getSuporteUsuariosRemuneracaoStore.setPage(value)
  }

  maskCnpj(value: any) {
    return maskCPFCNPJ(value)
  }

  dateMask(value: string) {
    return maskDate(value)
  }

  hourMask(value: string) {
    return maskHour(value)
  }

  async getItemsResults(page: number) {
    this.getPage = page
    this.tableLoading = true
    await this.getSuporteUsuariosRemuneracaoStore.getUsuarios()
    this.tableLoading = false
  }

  showModalLogs(usuario: any) {
    this.getSuporteUsuariosRemuneracaoStore.setLogs(usuario.logsLiberacao)
    this.getSuporteUsuariosRemuneracaoStore.setShowModalLogs(true)
  }

  showAdvancedFilters() {
    this.getSuporteUsuariosRemuneracaoStore.setDrawer(true)
  }

  async created() {
    this.tableLoading = true
    await this.getSuporteUsuariosRemuneracaoStore.getUsuarios()
    this.tableLoading = false
  }
}
